import copyObject from './_copyObject.js';
import keysIn from './keysIn.js';

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

export default baseAssignIn;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_baseAssignIn.js
// module id = 1042
// module chunks = 3